module.exports = __webpack_public_path__ + "813ca90581de7b76c7afd0a58cb3be11.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./components/Aside/images/bio-marc-02.jpg
 ** module id = 359
 ** module chunks = 0
 **/